export const categories = [
  {
    slug: 'dianying-tuijian',
    name: '电影推荐',
    description: '精选高分电影推荐，涵盖各类题材佳片',
    icon: 'ri-movie-2-line',
  },
  {
    slug: 'yingping-jiexi',
    name: '影评解析',
    description: '深度影评与剧情解析，帮你读懂电影',
    icon: 'ri-chat-quote-line',
  },
  {
    slug: 'juji-zhuizong',
    name: '剧集追踪',
    description: '热门电视剧追踪，精彩剧集一网打尽',
    icon: 'ri-tv-2-line',
  },
  {
    slug: 'yingshi-zixun',
    name: '影视资讯',
    description: '最新影视动态、上映信息和行业新闻',
    icon: 'ri-newspaper-line',
  },
  {
    slug: 'jingdian-huigu',
    name: '经典回顾',
    description: '重温影史经典，感受永恒魅力',
    icon: 'ri-vidicon-line',
  },
  {
    slug: 'guankan-zhinan',
    name: '观看指南',
    description: '观影平台推荐与高清资源指南',
    icon: 'ri-guide-line',
  },
];

export const articles = [
  {
    slug: 'mama-de-pengyou-quanwei-jiexi',
    title: '妈妈的朋友：一部关于成长与理解的情感力作',
    category: 'yingping-jiexi',
    excerpt: '电影《妈妈的朋友》以细腻的镜头语言和深刻的情感表达，讲述了一个关于家庭、成长与人性温暖的故事。本文将从剧情、表演、导演手法等多个维度进行深度解析。',
    content: `
      <h2>影片概述</h2>
      <p>《妈妈的朋友》是一部引人深思的韩国剧情片，影片以独特的视角展现了人与人之间微妙而真挚的情感联系。导演以细腻的笔触描绘了主人公在成长过程中遇到的困惑与感动，让观众在观影过程中产生强烈的共鸣。</p>
      
      <h2>剧情深度解析</h2>
      <p>影片的故事围绕着一位普通少年与母亲朋友之间展开。看似简单的人物关系背后，蕴含着对家庭、社会以及人性本质的深入探讨。导演巧妙地运用了大量象征性镜头，将人物内心的挣扎与成长过程表现得淋漓尽致。</p>
      <p>影片中的每个角色都塑造得十分立体，没有绝对的好与坏，而是通过复杂的人性描写，让观众看到每个人背后的故事和动机。这种叙事方式大大增强了影片的真实感和代入感。</p>
      
      <h2>表演艺术分析</h2>
      <p>主演们的精湛演技为这部作品增色不少。特别是女主角的表演，将角色的温柔、坚强与内心的矛盾诠释得入木三分。少年演员的自然表现同样令人印象深刻，那种青春期的迷茫与悸动被刻画得真实动人。</p>
      
      <h2>导演风格与镜头语言</h2>
      <p>导演在这部作品中展现出了成熟的叙事功力。大量使用自然光线和长镜头，营造出一种诗意般的视觉体验。影片的色调处理也别具匠心，温暖的色调贯穿始终，与影片的情感基调相得益彰。</p>
      
      <h2>社会意义与人文思考</h2>
      <p>《妈妈的朋友》不仅仅是一部娱乐性的电影，更是对当代社会人际关系的一次深刻反思。片中探讨的孤独、理解与成长的主题，具有普遍的人文意义，让每位观众都能从中找到自己的影子。</p>
      
      <h2>观影体验与推荐</h2>
      <p>整体而言，《妈妈的朋友》是一部值得反复品味的佳作。无论是从艺术性还是观赏性来看，都堪称上乘之作。推荐给喜欢深度剧情片、注重情感体验的观众。建议在安静的环境下观看，以便更好地感受影片传达的情感力量。</p>
    `,
    author: '影视评论员 李明',
    publishDate: '2026-08-05',
    readTime: '8分钟',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20warm%20cinematic%20film%20scene%20with%20soft%20golden%20lighting%2C%20two%20characters%20sitting%20in%20a%20cozy%20living%20room%2C%20emotional%20atmosphere%2C%20Korean%20film%20aesthetic%2C%20warm%20amber%20tones%2C%20shallow%20depth%20of%20field%2C%20cinematic%20composition%2C%20gentle%20expression&width=800&height=450&seq=article-cover-01&orientation=landscape',
    tags: ['韩国电影', '剧情片', '情感', '成长'],
  },
  {
    slug: '2026-nian-bikan-gaofen-dianying',
    title: '2026年必看十大高分电影推荐：影迷收藏指南',
    category: 'dianying-tuijian',
    excerpt: '2026年已经过半，电影市场涌现出众多优秀作品。我们为你精选了十部口碑与票房双丰收的必看电影，涵盖动作、剧情、科幻等多种类型，总有一部适合你。',
    content: `
      <h2>年度电影回顾</h2>
      <p>2026年的电影市场精彩纷呈，从年初到年中，多部优秀作品相继上映，为影迷们带来了一场又一场的视听盛宴。以下是我们精心挑选的十部必看高分电影。</p>
      
      <h2>1. 星际迷途：新纪元</h2>
      <p>这部科幻巨制以惊人的视觉效果和深刻的哲学思考征服了全球观众。导演在宏大的宇宙背景下探讨了人类存在的意义，IMAX观影体验震撼人心。</p>
      
      <h2>2. 归途</h2>
      <p>一部温情的公路电影，讲述了一对父女横跨半个中国寻找亲人的故事。朴实无华的叙事风格和真挚的情感表达让无数观众在影院落泪。</p>
      
      <h2>3. 暗影追踪</h2>
      <p>今年最令人意外的悬疑佳作，紧凑的剧情节奏和出人意料的结局反转，让这部电影成为年度黑马。导演对悬疑元素的把控堪称教科书级别。</p>
      
      <h2>4. 春天的约定</h2>
      <p>一部治愈系的文艺片，以细腻的笔触描绘了都市青年在大自然中寻找自我的故事。影片的摄影和配乐都达到了极高的水准。</p>
      
      <h2>5. 铁拳雄心</h2>
      <p>热血沸腾的拳击题材电影，不仅有令人血脉喷张的动作场面，更有感人至深的兄弟情谊。主演为这个角色付出了巨大的努力，呈现了令人信服的表演。</p>
    `,
    author: '编辑 王芳',
    publishDate: '2026-08-03',
    readTime: '6分钟',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20collection%20of%20movie%20posters%20displayed%20on%20a%20dark%20wall%20with%20warm%20spotlight%20illumination%2C%20cinematic%20atmosphere%2C%20film%20reels%20and%20tickets%20scattered%20on%20a%20wooden%20table%2C%20vintage%20cinema%20aesthetic%2C%20rich%20contrast%20lighting%2C%20nostalgic%20mood&width=800&height=450&seq=article-cover-02&orientation=landscape',
    tags: ['电影推荐', '高分电影', '2026', '影单'],
  },
  {
    slug: 'hanguo-juqingpian-jingxuan',
    title: '韩国剧情片精选：那些触动人心的温情佳作',
    category: 'dianying-tuijian',
    excerpt: '韩国电影以其独特的叙事风格和深刻的情感表达享誉全球。本文为你精选了几部近年来最受欢迎的韩国剧情片，每一部都值得你静心品味。',
    content: `
      <h2>韩国剧情片的独特魅力</h2>
      <p>韩国剧情片以其对社会现实的深刻洞察和对人性的细腻刻画而著称。这些电影往往能在平实的叙事中传递出强大的情感力量，让观众在观影后久久回味。</p>
      
      <h2>推荐一：妈妈的朋友</h2>
      <p>这部影片以温暖而不失深度的方式讲述了一个关于理解与成长的故事。影片中的情感处理细腻自然，演员表演真挚动人，是韩国剧情片中的一部佳作。</p>
      
      <h2>推荐二：寄生虫</h2>
      <p>奉俊昊导演的这部奥斯卡获奖作品，以黑色幽默的方式揭示了社会阶层的矛盾。影片的叙事结构精巧，隐喻丰富，是一部值得反复观看的经典之作。</p>
      
      <h2>推荐三：燃烧</h2>
      <p>李沧东导演的这部作品改编自村上春树的短篇小说，以诗意般的影像语言探讨了现代人的孤独与存在感。影片的氛围营造和演员表现都达到了极高的艺术水准。</p>
    `,
    author: '资深影迷 张伟',
    publishDate: '2026-07-28',
    readTime: '7分钟',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20film%20scene%20with%20warm%20autumn%20colors%2C%20two%20people%20walking%20along%20a%20tree-lined%20street%2C%20golden%20sunset%20light%2C%20emotional%20and%20peaceful%20atmosphere%2C%20cinematic%20depth%20of%20field%2C%20soft%20bokeh%20background&width=800&height=450&seq=article-cover-03&orientation=landscape',
    tags: ['韩国电影', '剧情片', '推荐', '温情'],
  },
  {
    slug: 'zai-xian-guankan-gaoqing-zhinan',
    title: '在线观看高清影视完整指南：平台推荐与技巧',
    category: 'guankan-zhinan',
    excerpt: '想在线观看高清完整版影视内容却不知道从何入手？本文为你整理了主流在线观看平台的特点和使用技巧，助你轻松享受流畅高清观影体验。',
    content: `
      <h2>主流在线观看平台概览</h2>
      <p>随着流媒体技术的发展，在线观看高清影视内容变得越来越便捷。不同的平台各有特色，了解它们的优势可以帮助你做出更好的选择。</p>
      
      <h2>平台推荐对比</h2>
      <p>当前主流的在线观看平台包括Netflix、爱奇艺、腾讯视频、优酷等。Netflix以原创内容和全球化资源见长；爱奇艺在国内版权资源丰富；腾讯视频在综艺和剧集方面优势明显。</p>
      
      <h2>高清流畅观看技巧</h2>
      <p>要想获得最佳的高清在线观看体验，需要注意以下几点：稳定的网络连接是基础，建议使用5GHz Wi-Fi或有线连接；选择合适的播放清晰度设置；避开高峰期观看可以获得更流畅的体验。</p>
      
      <h2>多端同步观看</h2>
      <p>现代在线观看平台普遍支持手机、平板、电脑和智能电视等多端同步。你可以随时随地切换设备继续观看，享受无缝的观影体验。</p>
    `,
    author: '技术支持 陈刚',
    publishDate: '2026-07-25',
    readTime: '5分钟',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20modern%20living%20room%20with%20a%20large%20TV%20screen%20displaying%20a%20film%2C%20cozy%20ambient%20lighting%2C%20a%20laptop%20and%20tablet%20on%20a%20coffee%20table%2C%20minimalist%20interior%20design%2C%20warm%20evening%20atmosphere%2C%20comfortable%20home%20cinema%20setup&width=800&height=450&seq=article-cover-04&orientation=landscape',
    tags: ['在线观看', '高清', '平台推荐', '观影指南'],
  },
  {
    slug: 'yingshi-zixun-zuixin-dongtai',
    title: '2026年8月影视资讯速递：新片上映与行业动态',
    category: 'yingshi-zixun',
    excerpt: '八月份有哪些值得期待的影视作品即将上映？影视行业又有哪些最新动态？本文为你汇总本月最重要的影视资讯，让你不错过任何精彩。',
    content: `
      <h2>八月新片上映日历</h2>
      <p>八月份有多部备受期待的电影即将登陆各大院线和流媒体平台。从国产大片到引进佳作，丰富的片单让影迷们有了更多的观影选择。</p>
      
      <h2>重点影片介绍</h2>
      <p>本月最受关注的影片包括动作大片《风暴追击》、文艺片《江南旧事》以及动画电影《星际探险家》。每部作品都有各自的看点，适合不同口味观众的需求。</p>
      
      <h2>行业动态速览</h2>
      <p>近期影视行业也有不少值得关注的消息。多个国际电影节公布了入围名单，中国电影在国际舞台上的影响力持续提升。同时，多家流媒体平台也在加大原创内容的投入力度。</p>
    `,
    author: '资讯记者 赵静',
    publishDate: '2026-08-01',
    readTime: '4分钟',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20cinema%20theater%20entrance%20with%20colorful%20movie%20posters%20on%20display%2C%20people%20walking%20in%2C%20warm%20theater%20lighting%2C%20marquee%20signs%2C%20excited%20atmosphere%2C%20modern%20cinema%20hall%2C%20cinematic%20composition&width=800&height=450&seq=article-cover-05&orientation=landscape',
    tags: ['影视资讯', '新片', '上映', '行业动态'],
  },
  {
    slug: 'jingdian-dianying-chongwen',
    title: '经典电影回顾：那些永不过时的影史杰作',
    category: 'jingdian-huigu',
    excerpt: '时光流转，有些电影却历久弥新。本文带你重温几部影史经典作品，探讨它们为何能够在几十年后依然闪耀着不朽的光芒。',
    content: `
      <h2>经典的定义</h2>
      <p>什么是经典电影？是那些能够穿越时间、文化和地域的限制，持续打动一代又一代观众的作品。它们或许拍摄于几十年前，但其中蕴含的情感和思考至今仍然鲜活。</p>
      
      <h2>肖申克的救赎</h2>
      <p>这部常年霸占各大电影排行榜榜首的作品，用希望和自由的主题打动了全世界观众。安迪在雨中获得自由的那一幕，成为了影史上最经典的场景之一。</p>
      
      <h2>阿甘正传</h2>
      <p>汤姆·汉克斯塑造的阿甘形象深入人心，影片通过一个"傻人"的视角，展现了美国几十年的历史变迁，既有笑点也有泪点，是一部真正的雅俗共赏之作。</p>
    `,
    author: '影评人 刘洋',
    publishDate: '2026-07-20',
    readTime: '6分钟',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20vintage%20film%20projector%20in%20a%20dark%20room%20projecting%20light%20onto%20a%20screen%2C%20classic%20movie%20posters%20on%20walls%2C%20old%20film%20reels%2C%20nostalgic%20cinema%20atmosphere%2C%20warm%20amber%20glow%2C%20dust%20particles%20in%20light%20beam&width=800&height=450&seq=article-cover-06&orientation=landscape',
    tags: ['经典电影', '回顾', '影史', '怀旧'],
  },
  {
    slug: 'rebo-dianshiju-zhuiying',
    title: '2026年夏季热播剧集追踪：不可错过的精彩好剧',
    category: 'juji-zhuizong',
    excerpt: '今年夏季档的电视剧竞争异常激烈，多部制作精良的剧集正在热播中。我们为你追踪这些话题度爆表的剧集，让你追剧不迷路。',
    content: `
      <h2>夏季档剧集概览</h2>
      <p>2026年夏季档的电视剧市场百花齐放，从都市情感到古装权谋，从悬疑推理到科幻冒险，各种类型应有尽有，满足了不同观众群体的追剧需求。</p>
      
      <h2>热播剧集推荐</h2>
      <p>《星辰大海》以精良的制作和跌宕起伏的剧情赢得了观众的喜爱；《都市夜话》则以其贴近生活的故事和出色的群像表演获得了口碑与收视双丰收。</p>
      
      <h2>追剧小贴士</h2>
      <p>为了获得最佳的追剧体验，建议合理安排观看时间，避免一次性观看过多集数。同时，可以关注官方社交媒体账号获取最新的更新信息。</p>
    `,
    author: '追剧达人 孙悦',
    publishDate: '2026-08-06',
    readTime: '5分钟',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20cozy%20bedroom%20at%20night%20with%20a%20laptop%20screen%20showing%20a%20TV%20series%2C%20warm%20blanket%20and%20pillows%2C%20soft%20string%20lights%2C%20comfortable%20and%20relaxing%20atmosphere%2C%20modern%20interior%2C%20evening%20mood&width=800&height=450&seq=article-cover-07&orientation=landscape',
    tags: ['热播剧', '追剧', '电视剧', '夏季档'],
  },
  {
    slug: 'dianying-muqian-hou-de-gushi',
    title: '电影幕后的故事：那些你不知道的拍摄趣闻',
    category: 'yingshi-zixun',
    excerpt: '一部好电影的诞生背后，往往有着许多鲜为人知的故事。从选角趣闻到拍摄花絮，从特效揭秘到导演心路，让我们一起来探索电影幕后的精彩世界。',
    content: `
      <h2>电影制作的幕后</h2>
      <p>每一部呈现在大银幕上的电影作品，背后都有着数百甚至数千名工作人员的辛勤付出。从剧本创作到后期制作，每一个环节都凝聚着无数人的心血和智慧。</p>
      
      <h2>选角趣闻</h2>
      <p>很多经典角色的诞生过程其实充满了偶然性。有些演员原本并非导演的首选，却因为各种机缘巧合而获得了角色，最终成就了银幕上的经典形象。</p>
      
      <h2>特效制作揭秘</h2>
      <p>现代电影中的视觉特效往往让观众叹为观止。然而，很多看似高科技的画面其实采用了巧妙的实拍技巧和道具设计，这背后凝聚了特效团队的无限创意。</p>
    `,
    author: '幕后记者 周婷',
    publishDate: '2026-07-15',
    readTime: '5分钟',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20film%20set%20behind%20the%20scenes%20with%20camera%20equipment%2C%20director%20chair%2C%20lighting%20rigs%2C%20clapperboard%2C%20crew%20members%20working%2C%20warm%20studio%20lighting%2C%20professional%20film%20production%20atmosphere%2C%20cinematic%20documentary%20style&width=800&height=450&seq=article-cover-08&orientation=landscape',
    tags: ['幕后', '拍摄', '花絮', '趣闻'],
  },
];

export const featuredArticles = articles.slice(0, 4);

export const heroArticle = articles[0];